module.exports = __webpack_public_path__ + "static/img/FRANCISCO_TOLEDO.3b76c21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/FRANCISCO_TOLEDO.jpg
// module id = mXYG
// module chunks = 1